import type { WizardStep } from '../../components/BbStepper'

/* The prototypes disagree with each other: six draw four steps, one draws five,
   and the labels vary (Select Entity / Select Source, Filter & Preview /
   Filter Records / Input Data, Review / Review Data, Confirm / Delete).

   These five are the set from batchbooks_delete_step_5_submitted — the only
   prototype that covers the submitted state, and the shape that matches how the
   import wizard ends on its own terminal step. */
export const DELETE_STEPS: WizardStep[] = [
  { key: 'source', label: 'Select Source' },
  { key: 'filter', label: 'Filter Records' },
  { key: 'review', label: 'Review Data' },
  { key: 'confirm', label: 'Confirm' },
  { key: 'delete', label: 'Delete' },
]
